export const ratingOptions = [
  {
    label: 'All',
    value: null,
  },
  {
    label: '1',
    value: 1,
  },
  {
    label: '2',
    value: 2,
  },
  {
    label: '3',
    value: 3,
  },
  {
    label: '4',
    value: 4,
  },
  {
    label: '5',
    value: 5,
  },
];

// Age is a Junip review `attributeRecord` (radio type), so it's filtered
// client-side against the fetched reviews rather than via the API query.
// `value` is the raw Junip attribute value; `label` is how we display it.
export const ageOptions = [
  { label: 'All', value: null },
  { label: 'Under 30', value: 'Under 30' },
  { label: '30-39', value: '30 to 39' },
  { label: '40-49', value: '40 to 49' },
  { label: '50-59', value: '50 to 59' },
  { label: '60-69', value: '60 to 69' },
  { label: 'Over 70', value: 'Over 70' },
];

export const MIN_NUM_OF_REVIEWS = 3;

export const MULTI_PRODUCT_RECOMMEND_LABEL = 'Would recommend';
export const SINGLE_PRODUCT_RECOMMEND_LABEL = 'Would recommend this product';
